﻿{
  "delivery.labels.deliveryCharge": "Liefergebühr",
  "portal.home.enquiries.noEnquiriesDescription": "Alle von Ihnen generierten Anfragen werden hier angezeigt.",
  "setup.product.labels.editGroup": "Gruppe bearbeiten",
  "dashboard.summary.table.date": "Datum",
  "setup.account.labels.endDate": "Enddatum",
  "menu.setup.retailOptionControl": "Endkundenoptionen verwalten",
  "setup.retail.validation.revertDefaultOrder": "Zur Standardreihenfolge zurückkehren",
  "portal.home.hero.expiring.text.line1": "Ihr Hersteller",
  "login.form.forgotPassword": "Passwort vergessen? Hier klicken!",
  "setup.retail.company.text.googleAnalytics.step1": "Geben Sie den auf Ihrer Website eingebetteten gtag‑Code ein.",
  "setup.account.financialDetails.labels.allowProductRequoteMarkups": "Zuschläge auf Produkte zulassen",
  "dashboard.welcome.allowMoreCustomers": "Ermöglichen Sie weiteren Kunden den Zugriff auf Funktionen zur Angebotserstellung und Bestellung.",
  "setup.costsPrices.labels.topRightPrice": "Preis oben rechts",
  "setup.retail.styling.labels.customerEmail": "Kunden‑E‑Mail‑Bestätigung einer neuen {setup}‑Anfrage",
  "dashboard.checklist.text.step4": "4. Wählen Sie aus, wie Sie Ihre Preise konfigurieren möchten",
  "setup.costsPrices.text.advancedPricing.line2": "Sobald Sie die erweiterten Preisoptionen eingerichtet haben, kann diese Einstellung weiterhin über die Funktion „Preis anpassen“ für die Schnellkalkulation überschrieben werden.",
  "labels.previewChanges": "Änderungen anzeigen",
  "business.home.welcome.allowMoreCustomers": "Ermöglichen Sie weiteren Kunden den Zugriff auf Funktionen zur Angebotserstellung und Bestellung.",
  "portal.menu.setup.products": "Produkte",
  "validation.delete": "Sind Sie sicher, dass Sie {item} löschen möchten?",
  "labels.taxRate": "Steuersätze",
  "dashboard.summary.brandedDisabled.description": "Noch heute Anfragen mit {retail} erstellen.",
  "labels.customer": "Kunde",
  "dashboard.knowledgeBase.articles.0.title": "Checkliste für die Einrichtung von {0}",
  "dashboard.welcome.links.help.description": "{touch} Support-Dokumente",
  "setup.costsPrices.labels.hardware": "Beschlag",
  "delivery.table.headers.thu": "Donnerstag",
  "setup.retail.styling.text.thankYouPageIntro": "Geben Sie hier die Unterüberschrift für die {setup}-Designer‑Dankeseite ein.",
  "dashboard.hero.expiring.cta.description": "{brandedMode} kaufen",
  "setup.costsPrices.labels.maxHeight": "Maximale Höhe",
  "portal.menu.setup.account": "Konto",
  "setup.costsPrices.labels.warningActivePricingMethods": "Warnung – Aktive Preisoptionen",
  "business.home.enquiries.generateEnquiries": "Endkundenanfragen erstellen, die Sie zur weiteren Bearbeitung an Ihre Kunden weiterleiten können.",
  "dashboard.hero.inactive.text.line1": "Nicht verpassen!",
  "dashboard.summary.dealer.description": "Kontaktieren Sie Ihren Hersteller, um bevorzugter Partner zu werden und kostenlose Anfragen zu erhalten.",
  "portal.home.enquiries.tips": "Tipps zur Bereitstellung zu {retail}",
  "setup.costsPrices.labels.minimumAreaForPricing": "Mindestfläche für die Preisberechnung",
  "business.home.welcome.description": "Willkommen in Ihrem {company} Dashboard",
  "portal.home.hero.active.text.line1": "Holen Sie das Beste heraus aus Ihrem ",
  "buttons.browse": "Durchsuchen",
  "pages.cost-list": "Kostenliste",
  "setup.costsPrices.text.possibleCombinedPricing": "Wenn andere Preisoptionen aktiviert sind, werden sie durch das Speichern an dieser Stelle nicht ersetzt. Die Optionen werden kombiniert und können die Endpreise verändern.",
  "menu.viewQuotes": "Angebote anzeigen",
  "dashboard.checklist.label.setupChecklist": "Checkliste für die Einrichtung von {product}",
  "setup.retail.company.text.rejectedEnquiries": "Wir senden an diese E‑Mail‑Adresse die Details zu allen abgelehnten Anfragen.",
  "portal.home.hero.active.text.list3": "Anregungen für Social‑Media‑Beiträge",
  "portal.home.knowledgeBase.hide.description.link": "Kontoseite",
  "portal.home.knowledgeBase.articles.0.title": "Checkliste für die Einrichtung von {0}",
  "setup.retail.company.text.googleAnalytics.step3.part1": "Öffnen Sie eine Seite Ihrer Website, die einen Link zum {setup}-Modus enthält.",
  "delivery.table.headers.fri": "Freitag",
  "labels.listOrder": "Auflistung Aufträge",
  "labels.processingLevels": "Verarbeitungsstufen",
  "setup.retail.styling.labels.emailSubject": "E‑Mail-Betreff",
  "public.login.form.cta": "Anmelden",
  "login.form.cta": "Anmelden",
  "setup.retail.knowledgeBase.links.video2": "Wie Sie {setup} kaufen.",
  "setup.costsPrices.labels.profiles": "Profile",
  "portal.menu.store": "{touch} Shop",
  "business.home.enquiries.table.postcode": "Postleitzahl",
  "pages.labour": "Arbeitsaufwand",
  "setup.costsPrices.labels.cornerJointAngled": "Stoß auf Gehrung",
  "global.images.requiredFileType": "Erforderlicher Dateityp: {fileTypes}",
  "setup.costsPrices.labels.discountCategory": "Rabattkategorie",
  "public.login.form.description": "Weiter zum Dashboard",
  "setup.styling.tooltip.quotePDFLastPageImage": "Laden Sie hier das Bild für die letzte Seite Ihrer Angebots‑PDF ein.",
  "login.form.inputs.email": "E-Mail",
  "setup.retail.validation.unsavedChanges": "Bitte speichern oder verwerfen Sie Ihre Änderungen, bevor Sie die Sortierreihenfolge ändern.",
  "dashboard.news.title": "News",
  "buttons.import": "Importieren",
  "shared.labels.country": "Land",
  "setup.retail.deployment.tooltips.deploy": "Klicken Sie hier, um Anleitungen zum Bereitstellen von {setup} auf Ihrer Website anzuzeigen.",
  "setup.styling.tooltip.loginPageBackgroundImage": "Laden Sie hier das Hintergrundbild für Ihre {touch}‑Portalanmeldeseite hoch.",
  "dashboard.hero.expiring.tag": "Jetzt handeln, um online zu bleiben",
  "delivery.table.headers.sat": "Samstag",
  "dashboard.summary.dealer.text": "Derzeit liegen keine Anfragen vor.",
  "setup.account.financialDetails.titleEdit": "Preisdaten bearbeiten",
  "menu.pendingOrders": "Ausstehende Aufträge",
  "setup.styling.tooltip.loginSubHeader": "Geben Sie hier den Untertiteltext für Ihre {touch}-Portalanmeldeseite ein.",
  "setup.costsPrices.labels.bottomRight": "Unten rechts",
  "shared.labels.address2": "Adresszeile 2",
  "dashboard.knowledgeBase.articles.5.title": "Design für Endkundenwebsite",
  "setup.retail.styling.text.enquiryPdfImage1.purpose": "Beschreibung: Ergänzt Ihre Unterlagen um ein Foto, das Ihr Produkt zeigt",
  "login.form.title": "Willkommen zurück!",
  "setup.retail.deployment.text.instruction": "Sobald Sie die oben genannten Schritte abgeschlossen haben, klicken Sie hier, um Anleitungen zur Einrichtung von {setup} anzuzeigen.",
  "setup.costsPrices.labels.jointCillWeld": "Fensterbankstoß - geschweißt",
  "dashboard.knowledgeBase.hide.description.link": "Kontoseite",
  "portal.home.enquiries.table.date": "Datum",
  "dashboard.hero.expiring.text.line2": "Unterstützte Abonnements",
  "delivery.table.headers.sun": "Sonntag",
  "dashboard.knowledgeBase.articles.4.title": "Wie Sie mit {1} Ihren Umsatz steigern.",
  "setup.retail.validation.revertCustomOrder": "Dadurch wird die Reihenfolge der Optionen im Retail Designer auf die Standardeinstellung zurückgesetzt.",
  "setup.retail.company.labels.newAddress": "Neue Adresse",
  "setup.retail.styling.text.enquiryPdfImage2.location": "Bereich: Design der letzten PDF-Seite, die an den Endkunden gesendet wird",
  "labels.phone": "Telefon",
  "setup.costsPrices.text.moveFinancialItemsWarning": "Bitte verschieben Sie alle preisrelevanten Einträge aus dieser Gruppe, bevor Sie sie löschen",
  "setup.costsPrices.labels.wastage": "Verschnitt",
  "setup.retail.labels.alias": "Alias",
  "setup.retail.deployment.text.option1.step1": "1) Klicken Sie unten auf die Schaltfläche „URL kopieren”.",
  "buttons.add": "Hinzufügen",
  "delivery.labels.deliveryType": "Lieferart",
  "setup.costsPrices.labels.minimumAreaForCosting": "Mindestfläche für die Kostenberechnung",
  "setup.costsPrices.labels.modifySelected": "Ausgewählte bearbeiten",
  "setup.retail.styling.text.landingPageTitle": "Geben Sie hier die Überschrift für die {setup}-Designer‑Seite ein.",
  "pages.alternate-sash-overlaps": "Alternativer Flügelüberstand",
  "setup.retail.company.text.googleAnalytics.step2.header": "Cross‑Domain‑Messungen einrichten",
  "dashboard.checklist.text.step5b": "Sie können Leads über Ihre Website, Ihre Social‑Media‑Kanäle oder in Ihren Ausstellungsräumen generieren.",
  "labels.products": "Produkte",
  "setup.costsPrices.labels.knockers": "Türklopfer",
  "dashboard.summary.brandedDisabled.text": "Derzeit liegen keine Anfragen vor.",
  "dashboard.support.manageNewsDescription": "Veröffentlichen Sie News, die Ihren Kunden im Portal angezeigt werden, und präsentieren Sie wichtige Produkt‑, Branchen‑ und Unternehmensinformationen.",
  "portal.home.hero.inactive.cta.description": "Kostenlose Funktionen aktivieren",
  "setup.costsPrices.labels.maxWidth": "Maximale Breite",
  "pages.details": "Details",
  "validation.staff.termsAndConditions": "Bitte akzeptieren Sie die allgemeinen Geschäftsbedingungen.",
  "delivery.labels.country": "Land",
  "setup.product.labels.sourceOverlaps": "Standardüberstände",
  "setup.retail.company.text.googleAnalytics.step3.header": "Prüfen, ob die Cross‑Domain‑Messungen funktionieren",
  "portal.home.knowledgeBase.articles.2.title": "Checkliste für die Einrichtung vom {1}",
  "public.login.store": "{touch} Shop",
  "dashboard.welcome.links.resources.description": "Broschüren & Anleitungen",
  "setup.retail.company.labels.thankYouPageRedirect": "Dankeseite Weiterleitung",
  "dashboard.summary.leadCapture.text": "{retail} ermöglicht es Ihnen, eigene Anfragen über Ihre Website, Ihre Social Media Kanäle und in Ihren Ausstellungsräumen zu erstellen.",
  "setup.costsPrices.labels.jointCillMech": "Fensterbankstoß - mechanisch",
  "portal.menu.news": "News",
  "setup.costsPrices.text.advancedPricing.line1": "Die erweiterten Preisoptionen geben Ihnen die vollständige Kontrolle über Ihre Auftragskosten. Sie ermöglichen es Ihnen außerdem, ein Produkt zu konfigurieren und den Preis in Echtzeit zu berechnen. Alle über den Lead‑Capture‑Designer generierten Anfragen werden automatisch bepreist, sobald sie in ein Angebot umgewandelt werden.",
  "portal.home.hero.expiring.cta.description": "{brandedMode} kaufen",
  "buttons.reset": "Zurücksetzen",
  "setup.costsPrices.labels.doorColour": "Türfarbe",
  "validation.rules.numeric": "{field} muss eine Zahl sein",
  "login.form.toggle.superuser": "Als Super‑User anmelden",
  "labels.firstName": "Vorname",
  "dashboard.checklist.text.step2": "2. Fügen Sie Ihre Teammitglieder hinzu",
  "delivery.table.headers.postcode": "Postleitzahl",
  "portal.home.knowledgeBase.hide.title": "Artikel ausblenden",
  "dashboard.hero.inactive.cta.description": "Kostenlose Funktionen aktivieren",
  "setup.costsPrices.labels.bottomLeft": "Unten links",
  "dashboard.enquiries.dealer.text": "Endkundenanfragen erstellen, die Sie zur weiteren Bearbeitung an Ihre Kunden weiterleiten können.",
  "setup.retail.deployment.text.option2.step2": "2) Platzieren Sie das Code‑Snippet in einem Container an der Stelle, an der es auf Ihrer Website angezeigt werden soll.",
  "setup.retail.company.text.googleAnalytics.step4.part1": "Anfrage senden",
  "delivery.labels.latitude": "Breitengrad",
  "pages.discount-categories": "Rabattkategorien",
  "setup.styling.labels.loginSubHeader": "Anmeldeseite - Untertitel",
  "dashboard.knowledgeBase.hide.cta": "Artikel ausblenden",
  "setup.retail.company.text.googleAnalytics.step2.part3": "Klicken Sie auf „Web“ und anschließend auf einen Web‑Datenstream.",
  "setup.retail.deployment.text.option2.title": "Option 2 – Im iFrame anzeigen",
  "setup.costsPrices.labels.cillJoint": "Fensterbankstoß",
  "setup.costsPrices.text.advancedPricing.line3": "Um die Einrichtung der erweiterten Preisoptionen abzuschließen, müssen Sie Folgendes konfigurieren:",
  "business.home.welcome.addStaff": "Mitarbeiter hinzufügen",
  "validation.unSavedChangesQuery": "Sie haben ungespeicherte Änderungen. Möchten Sie wirklich ohne zu speichern fortfahren?",
  "portal.home.hero.active.text.list4": "Und vieles mehr …",
  "business.menu.setup.retailOptionControl": "Endkundenoptionen verwalten",
  "delivery.labels.deliveryDays": "Liefertage",
  "portal.menu.viewEnquiries": "Anfragen anzeigen",
  "business.home.enquiries.from": "von {retail}",
  "setup.retail.company.text.googleAnalytics.step4.header": "Prüfen, ob die Konversionsdaten funktionieren",
  "setup.retail.products.labels.showToConsumers": "Für Endkunden anzeigen",
  "portal.home.news.from": "von",
  "business.menu.setup.delivery": "Lieferung",
  "business.menu.branches": "Zweigstellen",
  "dashboard.welcome.links.help.text": "Hilfeanleitungen",
  "login.description": "Melden Sie sich hier an, um {license}‑Angebote, Aufträge, Produkte, News, Dokumente und Medien sowie {retailType}‑Anfragen zu verwalten.",
  "delivery.table.headers.primary": "Primär",
  "setup.retail.styling.text.virtualHomeBanner.location": "Bereich: Warenkorbseite",
  "setup.retail.styling.text.thankYouPageBackground.purpose": "Beschreibung: Passt den Hintergrund der {setup} Dankeseite an.",
  "setup.costsPrices.labels.copyProductTo": "${productName} kopieren nach…",
  "buttons.submit": "Senden",
  "setup.costsPrices.labels.jointTAngledMech": "T‑Verbindung abgeschrägt – mechanisch",
  "portal.home.knowledgeBase.hide.cancel": "Abbrechen",
  "portal.home.welcome.description": "Willkommen beim {company} {license}",
  "pages.deployment": "Bereitstellung",
  "setup.retail.company.labels.selectAddress": "Adresse auswählen",
  "setup.styling.tooltip.emailBodyText": "Personalisieren Sie die Nachricht in Ihrer E‑Mail. Dies kann eine freundliche Begrüßung oder die Geschäftsbedingungen für {label} sein.",
  "setup.costsPrices.labels.bottomRightPrice": "Preis unten rechts",
  "setup.styling.tooltip.metaTitle": "Metatags können Sie verwenden, um Suchmaschinen zusätzliche Informationen über eine Seite bereitzustellen; zudem werden diese im Tab‑Titel angezeigt.“",
  "labels.email": "E-Mail",
  "menu.setup.delivery": "Lieferung",
  "dashboard.knowledgeBase.articles.2.title": "Checkliste für die Einrichtung vom {1}",
  "setup.costsPrices.labels.baseCost": "Grundkosten",
  "setup.retail.styling.text.instruction": "Bearbeiten Sie Bilder und Texte, um QUOTILA an Ihr Unternehmensdesign anzupassen. Sie können verschiedene Bereiche bearbeiten, darunter die Einleitung zum Unternehmensdesign, die Anfrageseite, VirtualHome, PDFs sowie die E‑Mail‑Korrespondenz an Ihre Kunden.",
  "setup.costsPrices.labels.general": "Allgemein",
  "dashboard.summary.leadCapture.button": "Einrichtung {retail}",
  "business.home.support.manageNewsDescription": "Veröffentlichen Sie News, die Ihren Kunden im Portal angezeigt werden, und präsentieren Sie wichtige Produkt‑, Branchen‑ und Unternehmensinformationen.",
  "shared.labels.state": "Bundesland/Provinz",
  "setup.styling.labels.requoteEmail": "{label} E-Mails",
  "setup.retail.products.labels.showOn": "In {setup} anzeigen",
  "setup.styling.labels.loginHeader": "Anmeldeseite - Kopfzeile",
  "menu.home": "Startseite",
  "setup.retail.styling.labels.landingPageBackground": "{setup} Landingpage Hintergrund",
  "shared.labels.firstName": "Vorname",
  "dashboard.enquiries.dealer.description": "Um auf {retail} zu upgraden, kontaktieren Sie das Vertriebsteam der BM Group unter",
  "shared.saveCustomer": "Kunde speichern",
  "setup.costsPrices.labels.cruciformJoint": "Kreuzstoß",
  "labels.branch": "Zweigstelle",
  "setup.costsPrices.labels.aperture": "Aperture",
  "setup.costsPrices.labels.groupName": "Gruppenname",
  "setup.retail.company.text.googleAnalytics.step4.text": "Ein Conversion‑Event wird enquiry-conversion genannt",
  "setup.retail.deployment.text.option2.notRecommended": "Nicht empfohlen bei Integration von Google Analytics",
  "dashboard.knowledgeBase.hide.cancel": "Abbrechen",
  "pages.settings": "Einstellungen",
  "validation.rules.maxLength": "{field} darf nicht mehr als {max} Zeichen enthalten",
  "setup.retail.styling.buttons.manageStyling": "Design verwalten",
  "dashboard.enquiries.table.customer": "Kunde",
  "dashboard.knowledgeBase.articles.7.title": "Individualisierte Website",
  "shared.labels.city": "Ort",
  "business.menu.pendingOrders": "Ausstehende Aufträge",
  "setup.costsPrices.labels.cornerJointSquare": "T-Stoß",
  "setup.retail.company.labels.yourAddress": "Ihre Adresse",
  "dashboard.enquiries.link": "Alle anzeigen",
  "delivery.table.headers.county": "Landkreis",
  "setup.retail.styling.text.landingPageIntro": "Geben Sie hier die Unterüberschrift für die {setup}-Designer‑Seite ein.",
  "dashboard.knowledgeBase.enquire": "Jetzt anfragen",
  "validation.rules.required": "{field} ist erforderlich",
  "business.home.kpi.quotesCreated": "Erstellte Angebote",
  "setup.costsPrices.labels.listPrice": "Auflistung Preise",
  "dashboard.summary.link": "Alle anzeigen",
  "setup.staff.titleAdd": "Mitarbeiter hinzufügen",
  "processing.labels.refusalReason": "Ablehnungsgrund",
  "public.login.form.inputs.email": "E-Mail",
  "setup.costsPrices.labels.jointCruciformMech": "Kreuzverbindung – mechanisch",
  "portal.home.hero.expiring.text.line3": "für {touch} ist...",
  "pages.account": "Konto",
  "global.images.recommendedSize": "Empfohlene Größe: {width}px × {height}px",
  "setup.costsPrices.labels.jointCornerAngledMech": "Eckverbindung abgeschrägt – mechanisch",
  "setup.retail.company.labels.logo": "Logo",
  "dashboard.welcome.links.resources.text": "Medien",
  "setup.costsPrices.labels.surveyCost": "Aufmaßkosten",
  "labels.type": "Typ",
  "pages.company": "Unternehmen",
  "setup.retail.validation.customOrderActive": "Der kundenspezifische Auftrag ist konfiguriert und <strong>aktiv</strong>. Deaktivieren Sie die Option oben, um die Änderungen rückgängig zu machen.",
  "pages.product-settings": "Produkteinstellungen",
  "public.login.form.inputs.username": "E-Mail",
  "pages.charges": "Gebühren",
  "setup.costsPrices.labels.itemColour": "Artikelfarbe",
  "dashboard.summary.table.postcode": "Postleitzahl",
  "setup.retail.styling.labels.emailBody": "E‑Mail‑Nachricht",
  "delivery.labels.address2": "Adresse 2",
  "login.form.inputs.confirmPassword": "Passwort bestätigen",
  "setup.costsPrices.labels.lists": "Listen",
  "labels.product": "Produkt",
  "menu.setup.costsPrices": "Kosten/Preise",
  "buttons.delete": "Löschen",
  "labels.country": "Land",
  "setup.retail.styling.labels.landingPageTitle": "Landingpage Titel",
  "setup.styling.tooltip.emailAddress": "Geben Sie hier die E‑Mail‑Adresse ein, um {label} als Absenderadresse zu verwenden.",
  "setup.product.labels.addGroup": "Gruppe hinzufügen",
  "setup.account.financialDetails.labels.taxValue": "Steuerwert",
  "setup.costsPrices.labels.doorDesigns": "Türdesigns",
  "setup.costsPrices.labels.price": "Preis",
  "setup.costsPrices.labels.jointButtWeld": "Stoßverbindung – geschweißt",
  "setup.retail.knowledgeBase.links.video1": "Wie Sie {setup} einrichten.",
  "portal.home.hero.active.cta.text": "{brandedMode} Tipps",
  "labels.admin": "Admin",
  "business.home.support.manageNews": "News verwalten",
  "labels.accountEnabled": "Konto aktiviert",
  "delivery.table.headers.mon": "Montag",
  "pages.styling": "Design",
  "labels.description": "Beschreibung",
  "labels.group": "Gruppe",
  "setup.retail.styling.labels.landingPageText": "{setup} Landingpage Text",
  "labels.enabled": "Aktiviert",
  "setup.retail.company.text.contractConfirmation": "Alle Ihre Angebote und Auftragsbestätigungen werden hierhin gesendet.",
  "setup.styling.labels.primaryLoginImage": "Titelbild für den Anmeldebereich",
  "setup.retail.company.labels.requestMeasurements": "Maße anfordern",
  "dashboard.hero.expiring.text.line4": "Läuft bald ab",
  "labels.none": "Keine",
  "setup.retail.company.text.showDesignNames": "Wählen Sie zwischen Design A und Design B, wenn ein Kunde einen Produkttyp auswählt.",
  "validation.staff.archivedStaff": "Mindestens ein Mitarbeiterkonto muss aktiviert bleiben.",
  "shared.buttons.save": "Speichern",
  "setup.retail.styling.text.thankYouPageBackground.location": "Bereich: (setup) Dankeseite",
  "setup.account.labels.startDate": "Startdatum",
  "labels.defaultContact": "Standardkontakt",
  "portal.menu.viewQuotes": "Angebote anzeigen",
  "setup.retail.company.text.googleAnalytics.step2.part5": "Klicken Sie im Bereich „Einstellungen“ auf „Domains konfigurieren“.",
  "labels.profilePhoto": "Profilbild",
  "pages.staff": "Mitarbeiter",
  "dashboard.summary.leadCapture.title": "Endkundenanfragen erstellen",
  "buttons.DragDrop": "Drag & drop",
  "dashboard.hero.active.text.list4": "Und vieles mehr …",
  "setup.product.labels.sourceClearances": "Referenzabstände",
  "public.login.title.line1": "Willkommen bei",
  "labels.requoteMarkup": "Zuschlag erneut berechnen",
  "setup.costsPrices.labels.nonRectangularPremium": "Modellscheibenzuschlag",
  "setup.retail.styling.labels.consumerEmail": "E‑Mail‑Bestätigung für Endkunden, dass {setup} Ihrem zugewiesenen Kunden zugeordnet wurde",
  "portal.menu.createOrder": "Auftrag erstellen",
  "pages.product": "Produkt",
  "labels.live": "Echtzeit",
  "business.home.kpi.daysAgo": "Die letzten {days} Tage",
  "labels.status": "Status",
  "pages.pricing-setup": "Preiskonfiguration",
  "labels.order": "Auftrag",
  "public.login.form.title": "Willkommen zurück!",
  "setup.styling.labels.requote": "Erneut anbieten",
  "setup.costsPrices.labels.itemCode": "Artikelcode",
  "setup.costsPrices.labels.baseFrameCost": "Grundkosten Rahmen",
  "dashboard.enquiries.table.postcode": "Postleitzahl",
  "pages.emails": "E-Mails",
  "portal.home.hero.inactive.text.line4": "Läuft bald ab",
  "dashboard.summary.table.cost": "Kosten",
  "login.form.description": "Weiter zum Dashboard",
  "business.menu.customers": "Kunden",
  "business.menu.setup.products": "Produkte",
  "setup.costsPrices.labels.quickPricing": "Schnellkalkulation",
  "setup.retail.styling.labels.virtualHomeBackground": "Virtual Home Hintergrund",
  "delivery.labels.leadTime": "Lieferzeit",
  "business.menu.news": "News",
  "business.menu.setup.staff": "Mitarbeiter",
  "portal.home.welcome.links.resources.text": "Medien",
  "validation.staff.defaultContact": "Es kann nur einen Standard‑Ticketkontakt geben. Dieser Benutzer wird nun der einzige Standardkontakt für Benutzer sein, die keinen eigenen Kontakt eingerichtet haben. Fortfahren?",
  "setup.costsPrices.labels.patterns": "Muster",
  "setup.costsPrices.labels.wholeNumber": "Ganze Zahl",
  "setup.styling.labels.quotation": "Angebot",
  "setup.costsPrices.labels.topLeftPrice": "Preis oben links",
  "setup.styling.tooltip.loginBodyText": "Geben Sie hier den Begrüßungstext ein, der auf Ihrer {touch}-Portalanmeldeseite unter den Überschriften angezeigt wird.",
  "setup.retail.deployment.text.option1.step2": "2) Fügen Sie diesen Link auf Ihrer Website ein. Wir empfehlen, ihn mit einer Schaltfläche oder einem Banner zu verknüpfen. Sie können den Link auch in der Navigation Ihrer Website platzieren.",
  "pages.imagesAndText": "Bilder & Text",
  "setup.retail.validation.applyCustomOrder": "Aktivieren Sie diese Option, um Ihre benutzerdefinierte Optionsreihenfolge im Retail‑Designer anzuwenden.",
  "setup.costsPrices.labels.partName": "Teilname",
  "setup.costsPrices.labels.markup": "Zuschlag",
  "dashboard.hero.inactive.text.line3": "{brandedMode}",
  "delivery.labels.town": "Ort",
  "shared.labels.address1": "Adresszeile 1",
  "setup.account.labels.usersPerAccount": "Benutzer pro Konto",
  "setup.costsPrices.labels.upliftCost": "Zuschlagskosten",
  "menu.viewEnquiries": "Anfragen anzeigen",
  "business.home.enquiries.upgrade": "Upgrade",
  "setup.retail.deployment.buttons.copyURL": "URL kopieren",
  "setup.retail.deployment.text.option1.title": "Option 1 – In neuem Fenster anzeigen",
  "setup.costsPrices.labels.spacerBars": "Abstandshalter",
  "pages.setup": "Einrichtung",
  "labels.active": "Aktiv",
  "labels.departments": "Abteilungen",
  "validation.rules.email": "{field} muss eine gültige E‑Mail‑Adresse sein",
  "setup.retail.deployment.text.option1.step3": "3) Sobald die Links hinzugefügt wurden, ist Ihr {setup} auf Ihrer Website live. Alle Änderungen, die Sie an Ihren Einstellungen vornehmen, werden automatisch auf Ihr aktives {setup} angewendet.",
  "setup.retail.company.text.paperwork": "Dies wird auf Ihren Unterlagen angezeigt, die an einen Kunden gesendet werden.",
  "pages.price-list": "Preisliste",
  "dashboard.knowledgeBase.articles.6.title": "Design der Händlerwebsite",
  "dashboard.hero.active.text.list2": "Ideen für Banner und Schaltflächen",
  "setup.costsPrices.labels.jointTAngledWeld": "T‑Verbindung abgeschrägt – geschweißt",
  "labels.step": "Schritt",
  "setup.retail.deployment.text.option2.step1": "1) Klicken Sie unten auf die Schaltfläche „iFrame kopieren”.",
  "setup.costsPrices.labels.numerals": "Ziffern",
  "portal.home.hero.inactive.text.line2": "Anfragen erstellen mit...",
  "labels.accountCode": "Kontocode",
  "portal.menu.setup.brandedMode.new": "Neu",
  "portal.home.knowledgeBase.articles.3.title": "Wie Sie {1} einrichten.",
  "setup.costsPrices.labels.bottomLeftCost": "Kosten unten links",
  "dashboard.hero.active.cta.description": "4 Tipps zur Generierung von Anfragen",
  "dashboard.welcome.addCustomer": "Kunde hinzufügen",
  "setup.costsPrices.labels.otherCorners": "Andere Ecken",
  "setup.retail.validation.customOrderInactive": "Der kundenspezifische Auftrag ist konfiguriert, aber <strong>nicht aktiv</strong>. Aktivieren Sie die Option oben, um die Änderungen anzuwenden.",
  "validation.rules.max": "{field} darf {max} nicht überschreiten",
  "setup.retail.company.text.enquiryOverdueLimit": "Wenn Sie eine {setup}-Anfrage zuweisen, legen Sie fest, wie lange der Kunde Zeit hat, darauf zu reagieren. Geben Sie eine Stundenzahl ein. Wird die Anfrage in diesem Zeitraum nicht bearbeitet, kann sie einem anderen Kunden zugewiesen werden.",
  "portal.home.enquiries.table.customer": "Kunde",
  "validation.rules.minMultiple": "Mindestens ein {field} liegt unter dem Mindestwert von {min}",
  "labels.index": "Index",
  "setup.retail.company.validation.yourAddress": "Sie haben keine gespeicherten Adressen.",
  "public.login.form.register": "Konto registrieren",
  "setup.styling.labels.emailBodyText": "E‑Mail‑Nachricht",
  "portal.home.knowledgeBase.articles.4.title": "Wie Sie mit {1} Ihren Umsatz steigern.",
  "dashboard.checklist.text.step3": "3. Personalisieren Sie Ihre Unterlagen",
  "setup.costsPrices.labels.upliftSelected": "Ausgewählter Zuschlag",
  "setup.styling.labels.loginPageBackgroundImage": "Anmeldeseite - Hintergrundbild",
  "setup.costsPrices.labels.reinforcing": "Verstärkung",
  "setup.retail.deployment.labels.deploy": "Bereitstellen",
  "business.home.enquiries.table.customer": "Kunde",
  "buttons.reorder": "Erneut erstellen",
  "labels.disabled": "Deaktiviert",
  "validation.staff.resendActivation": "Der Benutzer muss gespeichert werden, bevor die Aktivierung erneut gesendet werden kann",
  "setup.styling.labels.emailSubject": "E‑Mail-Betreff",
  "shared.labels.phone": "Telefon",
  "setup.costsPrices.labels.uplift": "Zuschlag",
  "portal.home.welcome.links.resources.description": "Broschüren & Anleitungen",
  "portal.home.hero.active.text.list2": "Ideen für Banner und Schaltflächen",
  "business.home.support.title": "Kunden-Support",
  "business.home.kpi.ordersPlaced": "Erstellte Aufträge",
  "dashboard.summary.brandedEnabled.text": "Sobald Sie {retail} bereitgestellt haben, werden alle von Ihnen erstellten Anfragen hier angezeigt.",
  "delivery.labels.primaryAddress": "Primäre Adresse",
  "setup.costsPrices.labels.rates": "Sätze",
  "labels.title": "Titel",
  "portal.home.hero.inactive.text.line1": "Nicht verpassen!",
  "setup.costsPrices.labels.frame": "Rahmen",
  "shared.labels.postcode": "Postleitzahl",
  "shared.labels.customerType": "Kundentyp",
  "setup.costsPrices.labels.tJointSquare": "T-Verbindung rechteckig",
  "validation.saveChanges": "Änderungen speichern?",
  "login.title.line1": "Willkommen bei",
  "dashboard.support.manageNews": "News verwalten",
  "menu.placedOrders": "Erfasste Aufträge",
  "business.home.enquiries.assign": "Zuweisen",
  "global.cookie.text": "Diese Website verwendet Cookies, um die Nutzererfahrung zu verbessern. Wir analysieren damit den Website‑Traffic und die Leistung. Personenbezogene Daten werden nur erhoben, wenn Sie dem zum Zeitpunkt der Erfassung ausdrücklich zustimmen; darüber informieren wir Sie vorab.",
  "global.search": "Suche {item}...",
  "setup.retail.styling.labels.FooterText": "Fußzeilentext",
  "pages.lead-times": "Lieferzeiten",
  "portal.home.knowledgeBase.store": "{touch} Shop",
  "dashboard.support.manageResources": "Medien verwalten",
  "delivery.table.headers.wed": "Mittwoch",
  "dashboard.summary.leadCapture.subtext": "Enthält Virtual Home",
  "menu.support": "Quick Support",
  "setup.costsPrices.labels.width": "Breite",
  "setup.costsPrices.labels.items": "Artikel",
  "business.home.enquiries.noEnquiriesDescription": "Alle Anfragen aus dem Händlernetzwerk werden hier angezeigt.",
  "buttons.continue": "Weiter",
  "pages.glass": "Glas",
  "setup.account.financialDetails.labels.linkedBranches": "Zugeordnete Zweigstellen",
  "buttons.update": "Aktualisieren",
  "business.menu.setup.account": "Konto",
  "portal.menu.home": "Startseite",
  "setup.styling.tooltip.loginHeader": "Geben Sie hier die Überschrift für Ihre {touch}-Portalanmeldeseite ein.",
  "setup.retail.styling.text.virtualHomeBackground.purpose": "Beschreibung: Passt den Hintergrund der Virtual‑Home‑Ansicht an.",
  "setup.costsPrices.labels.copiedFrom": "Kopiert von",
  "portal.home.enquiries.table.postcode": "Postleitzahl",
  "setup.costsPrices.labels.letterplates": "Einwurfklappen",
  "setup.costsPrices.labels.jointCornerAngledWeld": "Eckverbindung abgeschrägt – geschweißt",
  "buttons.remove": "Entfernen",
  "dashboard.enquiries.leadCapture.text": "{retail} ermöglicht es Ihnen, eigene Anfragen über Ihre Website, Ihre Social Media Kanäle und in Ihren Ausstellungsräumen zu erstellen.",
  "portal.menu.viewOrders": "Aufträge anzeigen",
  "labels.defaultTaxRate": "Standardsteuersatz",
  "setup.retail.styling.text.thankYouPageText": "Geben Sie hier die Überschrift für die {setup}-Designer‑Dankeseite ein.",
  "setup.costsPrices.labels.opener": "Öffner",
  "setup.retail.company.text.googleAnalytics.step2.part6": "Klicken Sie unter „Domains einbeziehen“ auf „Bedingung hinzufügen“ und setzen Sie den Übereinstimmungstyp auf „Genau übereinstimmt“.",
  "setup.costsPrices.text.warningActivePricingMethods.line2": "Dieser Abschnitt fügt eine weitere Preisoption hinzu. Wenn Sie bereits an anderer Stelle Preise definiert haben (z. B. Kosten + Zuschlag (Teileliste) oder Raster (Kostenliste/Preisliste)), bleiben diese bestehen – sie wirken ergänzend und können sich addieren. Soll diese Option die einzige Preisquelle sein, aktualisieren Sie zunächst die Werte hier und deaktivieren Sie anschließend die anderen Optionen. Andernfalls können in Angeboten und Aufträgen falsche Preise angezeigt werden.",
  "portal.home.hero.expiring.cta.text.expired": "Abgelaufen",
  "dashboard.summary.title": "Ihre Anfragen",
  "business.menu.resourceCentre": "Medienbibliothek",
  "delivery.labels.address3": "Adresse 3",
  "setup.account.financialDetails.labels.applyTaxToRequotes": "Steuer auf Zuschläge anwenden",
  "labels.archived": "Archiviert",
  "delivery.table.headers.line3": "Zeile 3",
  "pages.selections": "Auswahl",
  "dashboard.support.title": "Kunden-Support",
  "setup.retail.labels.visibleOptions": "Sichtbare Optionen",
  "labels.all": "Alle",
  "setup.product.labels.types": "Typen",
  "setup.account.delivery.action": "Adresse hinzufügen",
  "setup.retail.labels.metaTitle": "Meta-Titel",
  "dashboard.hero.active.text.list1": "Wie Sie Anfragen erzeugen.",
  "dashboard.checklist.text.step1": "1. Fügen Sie Ihre Unternehmensdetails und Ihr Logo hinzu",
  "setup.costsPrices.labels.financialGroups": "Preisgruppen",
  "portal.home.enquiries.generateEnquiries": "Noch heute Anfragen mit {retail} erstellen.",
  "business.menu.setup.text": "Einrichtung",
  "delivery.titleAdd": "Adresse hinzufügen",
  "setup.costsPrices.labels.decorations": "Dekor",
  "setup.costsPrices.labels.Step": "Schritt",
  "setup.retail.labels.selectedHeading": "Ausgewählte Überschrift",
  "business.menu.setup.paymentGateway": "Zahlungsanbieter",
  "labels.yes": "Ja",
  "dashboard.enquiries.leadCapture.subtext": "Enthält Virtual Home",
  "labels.vatRegistrationNumber": "Umsatzsteuer-Identifikationsnummer",
  "delivery.table.headers.line1": "Zeile 1",
  "setup.costsPrices.labels.copyTo": "Kopieren nach",
  "portal.home.enquiries.noEnquiriesReceived": "Derzeit liegen keine Anfragen vor.",
  "dashboard.kpi.ordersPlaced": "Erstellte Aufträge",
  "setup.account.labels.discountAmount": "Rabattbetrag",
  "setup.costsPrices.labels.grids": "Sprossen",
  "login.form.inputs.superuser": "Kunden-E-Mail",
  "global.cookie.title": "Cookie-Hinweis",
  "dashboard.news.cta": "Alle anzeigen",
  "setup.account.title": "Konto",
  "validation.product.atLeastOneEnabled": "Mindestens ein Produkt muss aktiviert sein",
  "shared.labels.email": "E-Mail",
  "setup.retail.company.text.googleAnalytics.step4.part2": "Zum Google‑Analytics‑Echtzeitbericht gehen. Sie sollten den Ereignisnamen mit mindestens einer Conversion neben dem Namen in der Kachel sehen.",
  "pages.products": "Produkte",
  "setup.staff.licenseLimit": "{active} von {limit} Lizenzen zugewiesen",
  "setup.retail.labels.iframeRedirect": "iFrame‑Weiterleitung",
  "setup.costsPrices.labels.spyholes": "Türspione",
  "dashboard.enquiries.assign": "Zuweisen",
  "portal.home.hero.inactive.cta.text": "Jetzt kaufen",
  "setup.costsPrices.labels.minHeight": "Minimale Höhe",
  "setup.costsPrices.labels.fanHoles": "Belüftungsöffnungen",
  "setup.product.tooltips.sourceOverlaps": "Profile mit Falztiefe von <b>{value}mm</b>",
  "dashboard.kpi.daysAgo": "Die letzten {days} Tage",
  "delivery.validation.latitudeLongitudeRequired": "Breitengrad & Längengrad sind für die geografische Auswahl über Anfragen erforderlich.",
  "setup.retail.styling.labels.thankYouPageIntro": "Dankeseite Einleitung",
  "setup.costsPrices.labels.sash": "Flügel",
  "dashboard.hero.inactive.text.line2": "Anfragen erstellen mit...",
  "setup.styling.labels.portalLoginPageText": "Text der Portalanmeldeseite",
  "setup.costsPrices.labels.profileColour": "Profilfarbe",
  "setup.retail.company.text.thankYouPageRedirect": "Kunden nach dem Absenden des Anfrageformulars im {setup}‑Modus zu einer benutzerdefinierten URL weiterleiten.",
  "business.home.kpi.generatedByYou": "von Ihnen erstellt",
  "dashboard.summary.assign": "Zuweisen",
  "menu.createOrder": "Auftrag erstellen",
  "validation.rules.minLength": "{field} muss mindestens {min} Zeichen lang sein",
  "shared.labels.lastName": "Nachname",
  "portal.home.knowledgeBase.articles.7.title": "Individualisierte Website",
  "dashboard.enquiries.dealer.upgrade": "Upgrade",
  "delivery.labels.day": "Tag",
  "setup.retail.deployment.labels.alias": "Alias",
  "delivery.labels.postCodeAreaMultiple": "Kommagetrennte Liste von Postleitzahlenbereichen eingeben",
  "setup.retail.styling.labels.thankYouPageBackground": "Dankeseite Hintergrund",
  "dashboard.welcome.addStaff": "Mitarbeiter hinzufügen",
  "login.form.register": "Konto registrieren",
  "setup.retail.tooltips.optionItems": "Einzelne Optionen für den Retail Designer aktivieren oder deaktivieren",
  "setup.costsPrices.labels.customerPrice": "Kundenpreis",
  "validation.product.greaterThanOrEqualTo": "<u>{fieldKeyA}</u> muss <strong>größer oder mindestens so groß</strong> sein wie <u>{fieldKeyB}</u>",
  "labels.no": "Nein",
  "portal.home.hero.active.text.list1": "Wie Sie Anfragen erzeugen.",
  "portal.menu.setup.brandedMode.text": "{brandedMode}",
  "delivery.labels.adjustCoordinates": "Koordinaten anpassen",
  "setup.costsPrices.labels.buttJoint": "Stumpfer Stoß",
  "labels.adminUser": "Admin-Benutzer",
  "portal.home.news.cta": "Alle anzeigen",
  "setup.retail.company.labels.enquiryOverdueLimit": "Zeitlimit für zugewiesene Anfragen",
  "setup.retail.styling.labels.enquiryPdfImage1": "Anfrage‑PDF Bild 1",
  "dashboard.hero.active.cta.text": "{brandedMode} Tipps",
  "setup.costsPrices.labels.jointButtMech": "Stoßverbindung – mechanisch",
  "setup.costsPrices.labels.types": "Typen",
  "menu.viewOrders": "Aufträge anzeigen",
  "setup.retail.company.validation.invalidTag": "Ungültiger Google-Tag",
  "portal.home.news.title": "News",
  "dashboard.checklist.text.step4b": "Sie können jetzt Angebote erstellen",
  "portal.home.hero.active.cta.description": "4 Tipps zur Generierung von Anfragen",
  "portal.home.hero.active.text.line2": "{brandedMode}",
  "setup.account.delivery.title": "Lieferadressen & Liefertage",
  "setup.retail.styling.text.landingPageBodyText": "Geben Sie hier den Begrüßungstext für die {setup}-Designer‑Seite ein.",
  "setup.retail.company.buttons.editAddress": "Adresse bearbeiten",
  "dashboard.enquiries.title": "Ihre Anfragen",
  "setup.retail.company.text.googleAnalytics.step3.part2": "Klicken Sie auf den Link und prüfen Sie, ob die URL der Ziel‑Domain den Linker‑Parameter _gl enthält.",
  "validation.rules.url": "{field} muss eine gültige URL sein",
  "setup.costsPrices.text.startPricingSetup": "Nutzen Sie die Tabs oben, um  mit der Preiskonfiguration zu starten.",
  "setup.styling.tooltip.primaryLoginImage": "Laden Sie hier das Titelbild für Ihre {touch}-Portalanmeldeseite hoch.",
  "setup.retail.styling.labels.FooterTitle": "Fußzeilentitel",
  "portal.home.welcome.links.help.text": "Hilfeanleitungen",
  "pages.dashboard": "Dashboard",
  "dashboard.summary.table.customer": "Kunde",
  "setup.account.financialDetails.labels.requoteTaxValue": "Steuer erneut berechnen",
  "portal.menu.support": "Quick Support",
  "labels.image": "Bild",
  "setup.retail.company.text.googleAnalytics.step2.part4": "Klicken Sie in den Web‑Stream‑Details unten auf „Tag‑Einstellungen konfigurieren“.",
  "buttons.revert": "Zurücksetzen",
  "portal.home.hero.inactive.tag": "Jetzt handeln, um online zu bleiben",
  "portal.home.knowledgeBase.articles.6.title": "Design der Händlerwebsite",
  "labels.code": "Code",
  "setup.styling.tooltip.quotePDFFirstPageImage": "Laden Sie hier das Bild für die erste Seite Ihrer Angebots‑PDF ein.",
  "delivery.labels.addressManual": "Adresse 1 (Manueller Modus – automatische Vervollständigung deaktiviert)",
  "dashboard.welcome.allowMoreStaff": "Erweitern Sie Ihr Team, indem Sie zusätzliche Mitarbeiter hinzufügen.",
  "dashboard.hero.expiring.cta.text.expiring": "Läuft ab",
  "setup.retail.styling.text.virtualHomeBanner.purpose": "Beschreibung: Startet die Virtual‑Home‑Funktion.",
  "validation.staff.resendActivationEmail": "Aktivierungs‑E‑Mail erneut senden",
  "login.store": "{touch} Shop",
  "delivery.labels.postCodeAreas": "Postleitzahlgebiete",
  "setup.costsPrices.labels.fittingMarkup": "Montageaufschlag",
  "setup.costsPrices.labels.beading": "Glasleiste",
  "dashboard.checklist.text.step5": "5. Lead‑Capture‑Designer einrichten",
  "portal.home.enquiries.title": "Ihre Anfragen",
  "labels.state": "Bundesland/Provinz",
  "validation.rules.requiredMultiple": "Mindestens ein {field} ist leer",
  "delivery.labels.deliveryDate": "Liefertage",
  "setup.retail.styling.labels.enquiryPdfImage2": "Anfrage‑PDF Bild 2",
  "portal.home.hero.expiring.tag": "Jetzt handeln, um online zu bleiben",
  "setup.product.labels.editType": "Typ bearbeiten",
  "setup.costsPrices.labels.bottomRightCost": "Kosten unten rechts",
  "portal.home.hero.expiring.text.line4": "Läuft bald ab",
  "dashboard.knowledgeBase.hide.description.text": "Bitte besuchen Sie {0}, um diese Änderung rückgängig zu machen",
  "setup.costsPrices.labels.jointTSquareMech": "T‑Verbindung rechtwinklig – mechanisch",
  "menu.setup.productSettings": "Produkteinstellungen",
  "delivery.labels.days": "Tage",
  "setup.retail.company.labels.showDesignNames": "Designnamen anzeigen",
  "setup.styling.labels.metaTitle": "Meta-Titel",
  "labels.companyRegistrationNumber": "Handelsregisternummer",
  "dashboard.kpi.quotesCreated": "Erstellte Angebote",
  "setup.retail.labels.overrideDefaultOrder": "Standardauftrag überschreiben",
  "setup.retail.styling.labels.landingPageBodyText": "Landingpage Haupttext",
  "portal.home.hero.expiring.cta.text.expiring": "Läuft ab",
  "labels.currency": "Währung",
  "portal.home.hero.inactive.text.line3": "{brandedMode}",
  "business.menu.setup.styling": "Design",
  "pages.requote-markups": "Zuschläge erneut berechnen",
  "menu.branches": "Zweigstellen",
  "business.menu.placedOrders": "Erfasste Aufträge",
  "buttons.save": "Änderungen speichern",
  "setup.retail.styling.labels.enquiryPdfSummaryFooter": "Anfrage‑PDF Zusammenfassung Fußzeile",
  "dashboard.welcome.description": "Willkommen in Ihrem {company} Dashboard",
  "validation.staff.activationEmailResent": "Aktivierungs‑E-Mail erneut gesendet",
  "setup.account.companyDetails.titleEdit": "Unternehmensdetails bearbeiten",
  "setup.costsPrices.labels.topLeftCost": "Kosten oben links",
  "setup.retail.knowledgeBase.text": "Wie Sie Videos und Anleitungen nutzen.",
  "menu.createQuote": "Angebot erstellen",
  "setup.styling.labels.quotePDFFirstPageImage": "Bild auf der ersten Angebots‑PDF‑Seite",
  "setup.retail.deployment.text.subHeader": "Wie Sie {setup} bereitstellen.",
  "labels.optional": "Optional",
  "setup.product.labels.fixedGlass": "Festverglasung",
  "setup.retail.deployment.text.option1.recommended": "Empfohlen",
  "portal.home.knowledgeBase.title": "Wissensdatenbank",
  "dashboard.welcome.text": "Hallo {name}...",
  "setup.retail.styling.text.virtualHomeBackground.location": "Bereich: Virtual Home",
  "setup.styling.labels.loginBodyText": "Anmeldeseite - Text",
  "setup.costsPrices.labels.minWidth": "Minimale Breite",
  "setup.costsPrices.labels.baseSashPrice": "Grundpreis Flügel",
  "delivery.labels.postCodeAreaList": "Liste der Postleitzahlgebiete",
  "setup.retail.styling.text.landingPageBackground.location": "Bereich: (setup) Designer‑Einführungsseite",
  "setup.costsPrices.labels.topRightCost": "Kosten oben rechts",
  "setup.product.labels.groups": "Gruppen",
  "setup.retail.styling.labels.thankYouPageBody": "Dankeseite Haupttext",
  "global.images.maxFileSize": "Maximale Dateigröße: {mb}MB",
  "setup.costsPrices.labels.topRight": "Oben rechts",
  "labels.optionHeadings": "Optionsüberschriften",
  "dashboard.hero.active.text.line2": "{brandedMode}",
  "portal.menu.setup.staff": "Mitarbeiter",
  "labels.address2": "Adresszeile 2",
  "menu.setup.staff": "Mitarbeiter",
  "buttons.replace": "Ersetzen",
  "setup.costsPrices.labels.globalPrice": "Globaler Preis",
  "setup.retail.styling.text.consumerEmail": "Geben Sie hier die E‑Mail‑Vorlage ein, um dem Endkunden zu bestätigen, welchem Kunden seine Anfrage zugewiesen wurde.",
  "pages.slab": "Türfüllung",
  "setup.costsPrices.labels.units": "Einheiten",
  "menu.news": "News",
  "setup.costsPrices.text.moveFinancialItemsConfirmation": "Sind Sie sicher, dass Sie (from) nach (to) verschieben möchten?",
  "portal.home.welcome.text": "Hallo {name}...",
  "pages.retail-option-control": "Endkundenoptionen verwalten",
  "setup.retail.company.text.googleAnalytics.step2.part1": "Zur Google‑Analytics‑Startseite gehen, die mit dem obigen gtag verknüpft ist.",
  "labels.category": "Kategorie",
  "setup.costsPrices.labels.netPrice": "Netto",
  "setup.costsPrices.labels.fixed": "Fest",
  "setup.costsPrices.labels.decorativeGlassDesign": "Dekorglas‑Design",
  "dashboard.enquiries.none.text": "Keine Anfragen eingegangen",
  "dashboard.knowledgeBase.articles.1.title": "Wie Sie {setup} kaufen.",
  "labels.contactNumber": "Kontaktnummer",
  "setup.retail.knowledgeBase.labels.knowledgeBase": "Wissensdatenbank",
  "business.home.enquiries.noEnquiriesReceived": "Keine Anfragen eingegangen",
  "pages.costs-prices": "Kosten & Preise",
  "labels.license": "Lizenz",
  "delivery.table.headers.country": "Land",
  "setup.costsPrices.text.wastageTooltip": "Der eingegebene Wert wirkt sich auf den für alle Stücklistenpositionen berechneten Verschnitt aus",
  "business.menu.cancelledOrders": "Stornierte Aufträge",
  "portal.menu.createQuote": "Angebot erstellen",
  "setup.retail.deployment.labels.howToDeploy": "Wie Sie {setup} bereitstellen.",
  "labels.salesContact": "Vertriebskontakt",
  "labels.optionItems": "Optionen",
  "portal.home.knowledgeBase.enquire": "Jetzt anfragen",
  "setup.costsPrices.text.selectMultipleBy": "Mehrfachauswahl über",
  "setup.product.labels.fittingCostPerProduct": "Montagekosten / Produkt",
  "labels.company": "Unternehmen",
  "setup.account.labels.totalUses": "Gesamtverwendung",
  "menu.resourceCentre": "Medienbibliothek",
  "labels.website": "Website",
  "setup.costsPrices.labels.jointTSquareWeld": "T‑Verbindung rechtwinklig – geschweißt",
  "buttons.goBack": "Zurück",
  "setup.retail.validation.overrideDefaultOrder": "Standardauftrag überschreiben",
  "setup.retail.styling.text.customerEmailAssignment": "Geben Sie hier die E‑Mail‑Vorlage ein, um Ihrem Kunden die Zuweisung einer {setup}-Anfrage in seinem Portal zu bestätigen.",
  "setup.retail.styling.text.enquiryPdfSummaryFooter": "Die letzte Seite der Anfrage‑PDF, unten im Zusammenfassungsbereich",
  "menu.setup.text": "Einrichtung",
  "shared.labels.company": "Unternehmen",
  "validation.product.greaterThan": "<u>{corner}</u> muss <strong>größer oder mindestens so groß</strong> sein wie die anderen Ecken",
  "setup.costsPrices.labels.baseSashCost": "Grundkosten Flügel",
  "delivery.labels.postcode": "Postleitzahl",
  "labels.searchBranch": "Zweigstelle suchen",
  "validation.unSavedChanges": "Es liegen ungespeicherte Änderungen vor",
  "setup.costsPrices.labels.joint": "Verbindung",
  "delivery.labels.deliveryOption": "Lieferoption",
  "menu.setup.paymentGateway": "Zahlungsanbieter",
  "setup.retail.company.text.googleAnalytics.step2.text": "Ermöglicht die eindeutige Zuordnung von Aktionen zu einem Benutzer über verschiedene Domains hinweg.",
  "setup.retail.styling.labels.enquiryEmailHeaderImage": "E‑Mail‑Headerbild für Anfragen",
  "setup.styling.tooltip.emailSubject": "Personalisieren Sie die Betreffzeile für {label}-E‑Mails, die an Endkunden gesendet werden.",
  "setup.account.labels.dateRange": "Datumsbereich",
  "labels.address1": "Adresszeile 1",
  "portal.home.enquiries.button": "Unternehmensdesign freischalten",
  "delivery.labels.addressSearch": "Adresse suchen",
  "setup.retail.company.buttons.refreshRequired": "Aktualisierung erforderlich",
  "setup.product.tooltips.sourceClearances": "Profile mit einem Referenzabstand von <b>{value} mm</b>",
  "menu.store": "{touch} Shop",
  "business.menu.home": "Startseite",
  "dashboard.checklist.text.setupChecklist": "Klicken Sie auf einen Abschnitt unten, um direkt dorthin zu gelangen.",
  "setup.costsPrices.labels.override": "Überschreiben",
  "setup.product.labels.fittingCostPerChildProduct": "Montagekosten / Teilprodukt",
  "validation.rules.numericMultiple": "Mindestens ein {field} ist keine Zahl",
  "setup.styling.labels.quotePDFLastPageImage": "Bild auf der letzten Angebots‑PDF‑Seite",
  "validation.staff.branchUsersNonAdmin": "Zweigstellenbenutzer verfügen nicht über Administratorrechte",
  "business.menu.store": "{touch} Shop",
  "setup.retail.styling.labels.virtualHomeBanner": "Virtual Home Banner ",
  "setup.retail.products.text": "Wählen Sie aus der Liste unten die Produkte aus, die Sie verkaufen. Diese werden anschließend in Ihrem {setup}-Designer angezeigt.",
  "business.home.enquiries.table.date": "Datum",
  "setup.costsPrices.labels.mech": "Mechanisch",
  "menu.knowledgeBase": "Wissensdatenbank",
  "dashboard.summary.brandedEnabled.tips": "Tipps zur Bereitstellung auf {retail}",
  "buttons.confirmAndSave": "Bestätigen & Speichern",
  "dashboard.hero.expiring.cta.text.expired": "Abgelaufen",
  "pages.parts-list": "Teileliste",
  "setup.account.labels.code": "Code",
  "setup.retail.company.text.googleAnalytics.step2.part7": "Domain Ihrer Website eingeben, z. B. example.com (ohne https)",
  "portal.home.hero.expiring.text.line2": "Unterstützte Abonnements",
  "setup.retail.deployment.text.option1.tip": "Hinweis: Dieser Link kann auch direkt in sozialen Medien gepostet werden, um weitere Anfragen zu generieren.",
  "delivery.labels.enterAddressManually": "Adresse manuell eingeben",
  "setup.costsPrices.labels.allCorners": "Alle Ecken",
  "login.form.inputs.password": "Passwort",
  "delivery.table.headers.tue": "Dienstag",
  "setup.retail.labels.hiddenOptions": "Ausgeblendete Optionen",
  "public.login.form.inputs.password": "Passwort",
  "dashboard.knowledgeBase.articles.3.title": "Wie Sie {1} einrichten.",
  "delivery.labels.minimumOrderValue": "Mindestbestellwert",
  "setup.account.financialDetails.labels.applyTax": "Steuer anwenden",
  "setup.costsPrices.text.quickPricing": "Sobald Sie ein Angebot erstellt oder eine Anfrage in ein Angebot umgewandelt haben, öffnen Sie die Angebotsdetailseite und klicken Sie auf „Preis anpassen“. So legen Sie den Auftragspreis fest, ohne die erweiterten Preisoptionen vollständig einrichten zu müssen.",
  "setup.costsPrices.labels.priceFromCostsPlusMarkup": "Preis aus Kosten plus Zuschlag",
  "setup.retail.styling.text.enquiryPdfImage2.purpose": "Beschreibung: Ergänzt Ihre Unterlagen um ein Foto, das Ihr Produkt zeigt",
  "menu.cancelledOrders": "Stornierte Aufträge",
  "pages.options": "Optionen",
  "shared.labels.defaultTaxRate": "Standardsteuersatz",
  "dashboard.support.manageResourcesDescription": "Ermöglichen Sie Ihren Kunden das Herunterladen von Dokumenten wie technischen Anleitungen, Broschüren, Grafiken, Fotos und weiteren Inhalten.",
  "setup.costsPrices.labels.basePrice": "Grundpreis",
  "buttons.cancel": "Abbrechen",
  "portal.home.enquiries.from": "von",
  "menu.setup.brandedMode.text": "{brandedMode}",
  "pages.financial-categories": "Preiskategorien",
  "buttons.undo": "Rückgängig",
  "pages.paperwork": "Unterlagen",
  "portal.home.knowledgeBase.articles.1.title": "Wie Sie {setup} kaufen.",
  "validation.rules.pattern": "{field} hat ein ungültiges Format",
  "buttons.selectAll": "Alle auswählen",
  "setup.costsPrices.labels.band": "Türband",
  "public.login.form.inputs.superuser": "Kunden-E-Mail",
  "setup.retail.styling.text.thankYouPageBody": "Geben Sie hier den Begrüßungstext für die {setup}-Designer‑Dankeseite ein.",
  "setup.costsPrices.labels.colours": "Farben",
  "setup.costsPrices.labels.designs": "Designs",
  "setup.styling.tooltip.portalLoginPageText": "Geben Sie hier den Text für Ihre {touch}-Portalanmeldeseite ein.",
  "dashboard.knowledgeBase.hide.title": "Artikel ausblenden",
  "delivery.labels.address1": "Adresse 1",
  "public.login.form.toggle.superuser": "Als Super‑User anmelden",
  "setup.costsPrices.labels.unitOfMeasure": "Maßeinheit",
  "setup.costsPrices.labels.addNewGroup": "Neue Gruppe hinzufügen",
  "delivery.table.headers.town": "Ort",
  "business.home.welcome.addCustomer": "Kunde hinzufügen",
  "setup.costsPrices.labels.ancillary": "Zusatzausstattung",
  "dashboard.hero.expiring.text.line3": "für {touch} ist...",
  "pages.delivery": "Lieferung",
  "delivery.labels.county": "Landkreis",
  "shared.cancel": "Abbrechen",
  "setup.costsPrices.text.warningActivePricingMethods.line1": "Wenn in den oberen Tabs aktive Preisoptionen eingerichtet sind, ersetzen die hier eingegebenen Preise die bestehenden Preisoptionen nicht. Die Optionen werden kombiniert. Aktualisieren Sie diesen Abschnitt und entfernen oder deaktivieren Sie andere Optionen, um falsche Gesamtsummen zu vermeiden.",
  "dashboard.hero.expiring.text.line1": "Ihr Hersteller",
  "pages.panel": "Paneel",
  "menu.setup.styling": "Design",
  "setup.costsPrices.labels.supplyMarkup": "Lieferzuschlag",
  "setup.retail.styling.text.enquiryEmailHeaderImage.location": "Bereich: Kopfzeile der E‑Mail‑Bestätigung, die der Nutzer nach dem Absenden einer Anfrage erhält",
  "setup.costsPrices.labels.possibleCombinedPricing": "Mögliche Preiskombinationen",
  "business.home.support.manageResources": "Medien verwalten",
  "dashboard.enquiries.none.description": "Alle Anfragen von {retail} werden hier angezeigt.",
  "setup.costsPrices.labels.baseFramePrice": "Grundpreis Rahmen",
  "shared.components.branding": "Von {brandName}",
  "setup.retail.styling.text.landingPageBackground.purpose": "Beschreibung: Passt die Landingpage für Ihre Kunden an, die {setup} besuchen",
  "delivery.labels.postCodeAreaPlaceholder": "Postleitzahlenpräfix hinzufügen…",
  "setup.costsPrices.labels.piece": "Stück",
  "dashboard.knowledgeBase.store": "{touch} Shop",
  "labels.noLogin": "Keine Anmeldung",
  "setup.costsPrices.labels.fittingCost": "Montagekosten",
  "global.branding": "Von {brandName}",
  "menu.setup.account": "Konto",
  "setup.costsPrices.labels.jointCornerSquareWeld": "Eckverbindung rechtwinklig – geschweißt",
  "portal.menu.knowledgeBase": "Wissensdatenbank",
  "menu.customers": "Kunden",
  "setup.costsPrices.text.setupPricing": "Wie möchten Sie Preise konfigurieren?",
  "setup.costsPrices.labels.backingGlass": "Dekorglas",
  "setup.retail.company.text.requestMeasurements": "Möchten Sie über den {setup}-Designer Maße von Ihren Kunden anfordern? Wenn ja, wird diese Frage auf der Einführungsseite angezeigt.",
  "labels.emailAddress": "E-Mail-Adresse",
  "dashboard.enquiries.leadCapture.button": "Einrichtung {retail}",
  "setup.retail.styling.text.enquiryEmailHeaderImage.purpose": "Beschreibung: Ergänzt Ihre Unterlagen um ein Foto, das Ihr Produkt zeigt",
  "labels.phoneNumber": "Telefonnummer",
  "dashboard.enquiries.leadCapture.title": "Endkundenanfragen erstellen",
  "setup.costsPrices.labels.bottomLeftPrice": "Preis unten links",
  "portal.home.welcome.links.help.description": "{touch} Support-Dokumente",
  "setup.costsPrices.labels.upliftPrice": "Preisaufschlag",
  "labels.customerType": "Kundentyp",
  "public.login.form.forgotPassword": "Passwort vergessen? Hier klicken!",
  "buttons.readMore": "Weiterlesen",
  "setup.retail.deployment.buttons.copyIframe": "iFrame kopieren",
  "portal.menu.setup.styling": "Design",
  "setup.retail.styling.labels.customText": "Benutzerdefinierter Text",
  "setup.costsPrices.labels.cost": "Kosten",
  "labels.city": "Ort",
  "setup.costsPrices.text.costMarkupTooltip": "Der eingegebene Wert wirkt sich nur auf die Preisoptionen „Kosten + Zuschlag“ aus.",
  "setup.product.labels.addType": "Typ hinzufügen",
  "validation.passwordsNoMatch": "Passwörter stimmen nicht überein",
  "setup.retail.tooltips.hiddenOptions": "Ausgeblendete Optionen zum Retail Designer hinzufügen",
  "validation.rules.wholeNumber": "{field} muss eine ganze Zahl sein",
  "setup.retail.deployment.tooltips.alias": "Personalisieren Sie die URL bzw. Webadresse für Ihr {setup}. Dies ist in der Regel Ihr Firmenname.",
  "setup.costsPrices.labels.customerPrices": "Kundenpreise",
  "business.home.welcome.allowMoreStaff": "Erweitern Sie Ihr Team, indem Sie zusätzliche Mitarbeiter hinzufügen.",
  "portal.home.enquiries.generateDealerEnquiries": "Kontaktieren Sie Ihren Hersteller, um bevorzugter Partner zu werden und kostenlose Anfragen zu erhalten.",
  "dashboard.kpi.enquiries": "{retail} Anfragen",
  "setup.retail.company.text.googleAnalytics.step2.part8": "Wiederholen Sie Schritt 6 und geben Sie die Domain für den Designer ein: bm-touch.co.uk.",
  "business.home.kpi.enquiries": "{retail} Anfragen",
  "setup.costsPrices.labels.gasFill": "Gasfüllung",
  "dashboard.hero.active.text.list3": "Anregungen für Social‑Media‑Beiträge",
  "setup.costsPrices.labels.weight": "Gewicht",
  "setup.retail.deployment.text.gpdr": "Bitte laden Sie Ihre DSGVO‑Dokumente hoch. Anschließend können Sie diese in Ihrem Designer bereitstellen.",
  "portal.menu.setup.costsPrices": "Kosten/Preise",
  "public.login.description": "Melden Sie sich hier an, um {license}‑Angebote, Aufträge, Produkte, News, Dokumente und Medien sowie {retailType}‑Anfragen zu verwalten.",
  "dashboard.enquiries.table.date": "Datum",
  "setup.product.labels.sashGlass": "Glasfensterflügel",
  "portal.home.knowledgeBase.hide.description.text": "Bitte besuchen Sie {0}, um diese Änderung rückgängig zu machen",
  "validation.rules.min": "{field} muss mindestens {min} sein",
  "labels.lastName": "Nachname",
  "setup.costsPrices.labels.jointCruciformWeld": "Kreuzverbindung – geschweißt",
  "buttons.confirm": "Bestätigen",
  "setup.retail.company.text.googleAnalytics.compatibleWith": "Nicht kompatibel mit Bereitstellung 2 (iFrame‑Bereitstellung). Bitte wählen Sie Bereitstellung 1.",
  "dashboard.hero.inactive.cta.text": "{brandedMode} ausprobieren",
  "setup.costsPrices.labels.doorGlass": "Türglas",
  "delivery.labels.deliveryAddress": "Lieferadresse",
  "portal.home.knowledgeBase.hide.cta": "Artikel ausblenden",
  "business.home.enquiries.contactUs": "Um auf das Händlernetzwerk upzugraden, kontaktieren Sie das Vertriebsteam der BM Group",
  "shared.labels.website": "Website",
  "business.home.enquiries.assignEnquiries": "{retail}‑Anfragen zuweisen",
  "delivery.titleEdit": "Adresse bearbeiten",
  "setup.costsPrices.labels.weld": "Schweißung",
  "setup.retail.company.text.googleAnalytics.step2.part2": "Klicken Sie in „Admin“ unter „Datenerfassung und ‑bearbeitung“ auf „Data Streams“.",
  "validation.noResults": "Keine Ergebnisse gefunden",
  "labels.address": "Adresse",
  "setup.retail.styling.labels.landingPageIntro": "Landingpage Einleitung",
  "setup.retail.styling.labels.thankYouPageTitle": "Dankeseite Titel",
  "pages.slab-glass-bands": "Ganzglas-Türenbänder",
  "dashboard.kpi.generatedByYou": "von Ihnen erstellt",
  "setup.costsPrices.labels.glazing": "Verglasung",
  "setup.retail.labels.optionItems": "Optionen",
  "setup.costsPrices.labels.per": "Pro",
  "setup.retail.styling.labels.thankYouPageText": "{setup} Dankeseite Text",
  "setup.account.header.AccountCode": "Kontocode",
  "business.home.support.manageResourcesDescription": "Ermöglichen Sie Ihren Kunden das Herunterladen von Dokumenten wie technischen Anleitungen, Broschüren, Grafiken, Fotos und weiteren Inhalten.",
  "dashboard.knowledgeBase.title": "Wissensdatenbank",
  "setup.retail.tooltips.visibleOptions": "Sichtbare Optionen für den Retail Designer anpassen",
  "setup.costsPrices.labels.sashOverlap": "Flügelüberstand",
  "portal.home.enquiries.assign": "Zuweisen",
  "labels.value": "Wert",
  "portal.menu.setup.text": "Einrichtung",
  "setup.costsPrices.text.setupPricingDescription": "Wählen Sie zwischen der Schnellkalkulation für einfache Aufträge oder den erweiterten Preisoptionen für eine genaue, positionsbasierte Preisberechnung.",
  "setup.retail.styling.text.customerEmailRecieved": "Geben Sie hier die E‑Mail‑Vorlage ein, um Ihrem Kunden den Eingang seiner Anfrage zu bestätigen.",
  "setup.costsPrices.labels.advancedPricing": "Erweiterte Preisoptionen",
  "buttons.create": "Erstellen",
  "dashboard.knowledgeBase.articles.8.title": "{2}",
  "setup.retail.styling.text.enquiryPdfImage1.location": "Bereich: Design der ersten PDF-Seite, die an den Endkunden gesendet wird",
  "validation.product.lessThanOrEqualTo": "<u>{fieldKeyA}</u> muss <strong>kleiner oder mindestens so klein</strong> sein wie <u>{fieldKeyB}</u>",
  "setup.costsPrices.labels.height": "Höhe",
  "business.menu.setup.costsPrices": "Kosten/Preise",
  "pages.alternate-glass-clearance": "Alternativer Glasabstand",
  "labels.notes": "Hinweise",
  "setup.retail.knowledgeBase.links.video3": "Wie Sie die Funktion „Virtual Home“ verwenden.",
  "labels.postcode": "Postleitzahl",
  "setup.costsPrices.labels.topLeft": "Oben links",
  "dashboard.hero.active.text.line1": "Holen Sie das Beste heraus aus Ihrem ",
  "dashboard.news.from": "von",
  "setup.costsPrices.labels.angled": "Abgewinkelt",
  "delivery.labels.longitude": "Längengrad",
  "setup.costsPrices.labels.jointCornerSquareMech": "Eckverbindung rechtwinklig – mechanisch",
  "business.menu.viewEnquiries": "Anfragen anzeigen",
  "delivery.table.headers.line2": "Zeile 2",
  "business.home.welcome.text": "Hallo {name}...",
  "portal.menu.resourceCentre": "Medienbibliothek",
  "setup.costsPrices.labels.financialCategory": "Preiskategorie",
  "delivery.labels.onward": "Weiter",
  "shared.labels.searchBranch": "Zweigstelle suchen",
  "labels.name": "Name",
  "setup.retail.company.validation.invalidTagHtml": "Bitte geben Sie <strong>G-</strong> nicht als Teil des Codes ein.",
  "setup.costsPrices.labels.noMarkupToPrice": "Keine Zuschläge auf den Preis",
  "business.menu.knowledgeBase": "Wissensdatenbank",
  "setup.retail.company.text.googleAnalytics.setup": "Richten Sie Analytics ein, um den Traffic & die Conversions in {setup} zu messen.",
  "portal.home.knowledgeBase.articles.5.title": "Design für Endkundenwebsite",
  "buttons.rename": "Umbenennen",
  "setup.costsPrices.labels.tJointAngled": "T-Verbindung abgeschrägt",
  "dashboard.summary.brandedDisabled.button": "Kostenlose Testphase starten",
  "portal.home.knowledgeBase.articles.8.title": "{2}"
}